import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { getChaptersWithParagraphs } from 'tip/selectors/chapter';
import ChapterList from 'tip/components/ChapterList';
import {
  updateChapter,
  moveChapterUp,
  moveChapterDown,
  removeChapter,
} from 'tip/actions/chapters';
import {
  createImageParagraph,
  moveParagraphUp,
  moveParagraphDown,
  removeParagraph,
} from 'tip/actions/paragraphs';

const mapStateToProps = state => ({
  chapters: getChaptersWithParagraphs(state),
});
const mapDispatchToProps = dispatch => ({
  updateChapter: (chapter, name) => dispatch(updateChapter(chapter, name)),
  moveChapterUp: chapter => dispatch(moveChapterUp(chapter)),
  moveChapterDown: chapter => dispatch(moveChapterDown(chapter)),
  removeChapter: chapter => dispatch(removeChapter(chapter)),
  createImageParagraph: (chapter, image) =>
    dispatch(createImageParagraph(chapter, image)),
  moveParagraphUp: paragraph => dispatch(moveParagraphUp(paragraph)),
  moveParagraphDown: paragraph => dispatch(moveParagraphDown(paragraph)),
  removeParagraph: paragraph => dispatch(removeParagraph(paragraph)),
});
const ChaptersPage = ({
  chapters,
  updateChapter,
  moveChapterUp,
  moveChapterDown,
  removeChapter,
  createImageParagraph,
  moveParagraphUp,
  moveParagraphDown,
  removeParagraph,
}) => (
  <div>
    <ChapterList
      chapters={chapters}
      chapterCount={chapters.length}
      update={updateChapter}
      moveUp={moveChapterUp}
      moveDown={moveChapterDown}
      remove={removeChapter}
      createImageParagraph={createImageParagraph}
      moveParagraphUp={moveParagraphUp}
      moveParagraphDown={moveParagraphDown}
      removeParagraph={removeParagraph}
    />
  </div>
);

ChaptersPage.propTypes = {
  chapters: PropTypes.array.isRequired,
  updateChapter: PropTypes.func.isRequired,
  moveChapterUp: PropTypes.func.isRequired,
  moveChapterDown: PropTypes.func.isRequired,
  createImageParagraph: PropTypes.func.isRequired,
  moveParagraphDown: PropTypes.func.isRequired,
  moveParagraphUp: PropTypes.func.isRequired,
  removeParagraph: PropTypes.func.isRequired,
  removeChapter: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChaptersPage);



// WEBPACK FOOTER //
// ./src/modules/tip/pages/ChaptersPage.js